module.exports = __webpack_public_path__ + "static/img/solutionAdvantageIcon04.a88f72a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionAdvantageIcon04.png
// module id = fhaD
// module chunks = 0